// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__26cie","inner":"Footer_inner__35KL7"};